import React, {useEffect, useState} from 'react'

import {bool, combine} from '../styles/classname-utils'
import classes from './pricing-features-table.module.scss'
import checkMarkGreen from '../../img/checkmark-green.svg'
import xmark from '../../img/xmark.svg'

const PricingFeaturesTable = (showFeaturesTable) => {
  const [sticky, setSticky] = useState(false)
  const featured = (
    <img
      className={classes.featuredIcon}
      src={checkMarkGreen}
      alt='Featured'
    />
  )
  const notFeatured = (
    <img
      className={classes.notFeaturedIcon}
      src={xmark}
      alt='Not Featured'
    />
  )
  const infinity = (
    <b className={combine('text-center', classes.unlimitedFont)}>Unlimited</b>
  )
  const rowHeader = classes.tableRowHeader
  const tableSubHeader = combine(classes.tableSubHeader, 'text-center text-md-left font8-bold')
  const tableCell = combine('d-flex justify-content-center align-items-center', classes.tableCell)
  const tableRow = combine('d-flex flex-wrap', classes.tableRow)

  useEffect(() => {
    if (sticky) {
      setSticky(false)
    } else {
      setTimeout(() => { setSticky(true) }, 500)
    }
  }, [showFeaturesTable])

  return (
    <div className={classes.tableContainer}>
      <div className={combine(bool(sticky, 'sticky-top'), classes.tableHeader, tableRow)}>
        <div className={rowHeader}>
          Features
        </div>
        <div className={tableCell}>Starter</div>
        <div className={tableCell}>Plus</div>
        <div className={tableCell}>Pro</div>
        <div className={tableCell}>Enterprise</div>
      </div>

      <div className={tableSubHeader}>8th Wall Engine</div>
      <div className={tableRow}>
        <div className={rowHeader}>
          8th Wall Engine (World Effects, Lightship VPS, Face Effects, Image Targets)
        </div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
      </div>
      <div className={tableRow}>
        <div className={rowHeader}>
          Modular camera application framework
        </div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
      </div>
      <div className={tableRow}>
        <div className={rowHeader}>
          Metaversal Deployment
        </div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
      </div>
      <div className={tableRow}>
        <div className={rowHeader}>
          Media Recorder
        </div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
      </div>
      <div className={tableRow}>
        <div className={rowHeader}>
          Volumetric video playback (holograms)
        </div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
      </div>
      <div className={tableRow}>
        <div className={rowHeader}>
          Avatar integrations
        </div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
      </div>
      <div className={tableRow}>
        <div className={rowHeader}>
          Exclusive platform APIs
        </div>
        <div className={tableCell}>{notFeatured}</div>
        <div className={tableCell}>{notFeatured}</div>
        <div className={tableCell}>{notFeatured}</div>
        <div className={tableCell}>{featured}</div>
      </div>


      <div className={tableSubHeader}>Project Development</div>
      <div className={tableRow}>
        <div className={rowHeader}>
          Team size
        </div>
        <div className={tableCell}><b>3</b></div>
        <div className={tableCell}><b>6</b></div>
        <div className={tableCell}>{infinity}</div>
        <div className={tableCell}>{infinity}</div>
      </div>
      <div className={tableRow}>
        <div className={rowHeader}>
          Develop commercial web applications on behalf of clients
        </div>
        <div className={tableCell}>{notFeatured}</div>
        <div className={tableCell}>{notFeatured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
      </div>
      <div className={tableRow}>
        <div className={rowHeader}>
          Purchase licenses for commercial use by clients
        </div>
        <div className={tableCell}>{notFeatured}</div>
        <div className={tableCell}>{notFeatured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{notFeatured}</div>
      </div>
      <div className={tableRow}>
        <div className={rowHeader}>
          Custom contracts and invoicing
        </div>
        <div className={tableCell}>{notFeatured}</div>
        <div className={tableCell}>{notFeatured}</div>
        <div className={tableCell}>{notFeatured}</div>
        <div className={tableCell}>{featured}</div>
      </div>
      <div className={tableRow}>
        <div className={rowHeader}>
          Volume pricing
        </div>
        <div className={tableCell}>{notFeatured}</div>
        <div className={tableCell}>{notFeatured}</div>
        <div className={tableCell}>{notFeatured}</div>
        <div className={tableCell}>{featured}</div>
      </div>
      <div className={tableRow}>
        <div className={rowHeader}>
          Share projects with other workspaces for collaboration
        </div>
        <div className={tableCell}>{notFeatured}</div>
        <div className={tableCell}>{notFeatured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
      </div>
      <div className={tableRow}>
        <div className={rowHeader}>
          Accept invitations to work on shared projects
        </div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
      </div>

      <div className={tableSubHeader}>Developer Tools</div>
      <div className={tableRow}>
        <div className={rowHeader}>
          Cloud Editor
        </div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
      </div>
      <div className={tableRow}>
        <div className={rowHeader}>
          Remote debugging
        </div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
      </div>
      <div className={tableRow}>
        <div className={rowHeader}>
          Integrated source control
        </div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
      </div>
      <div className={tableRow}>
        <div className={rowHeader}>
          Local development (App Key)
        </div>
        <div className={tableCell}>{notFeatured}</div>
        <div className={tableCell}>{notFeatured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
      </div>
      <div className={tableRow}>
        <div className={rowHeader}>
          8th Wall Payments
        </div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
      </div>
      <div className={tableRow}>
        <div className={rowHeader}>
          External analytics
        </div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
      </div>

      <div className={tableSubHeader}>Publishing &amp; Sharing</div>
      <div className={tableRow}>
        <div className={rowHeader}>
          Unlimited projects
        </div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
      </div>
      <div className={tableRow}>
        <div className={rowHeader}>
          8th Wall hosting
        </div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
      </div>
      <div className={tableRow}>
        <div className={rowHeader}>
          Self hosting
        </div>
        <div className={tableCell}>{notFeatured}</div>
        <div className={tableCell}>{notFeatured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
      </div>
      <div className={tableRow}>
        <div className={rowHeader}>
          Password-protected staging environment
        </div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
      </div>
      <div className={tableRow}>
        <div className={rowHeader}>
          Remove default splash screen (commercial projects only)
        </div>
        <div className={tableCell}>{notFeatured}</div>
        <div className={tableCell}>{notFeatured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
      </div>
      <div className={tableRow}>
        <div className={rowHeader}>
          Public Profile on <a href='/'>8thwall.com</a>
        </div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
      </div>
      <div className={tableRow}>
        <div className={rowHeader}>
          Feature projects on <a href='/discover'>8thwall.com/discover</a>
        </div>
        <div className={tableCell}>{notFeatured}</div>
        <div className={tableCell}>{notFeatured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
      </div>
      <div className={tableRow}>
        <div className={rowHeader}>
          Launch project using direct URLs
        </div>
        <div className={tableCell}>{notFeatured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
      </div>
      <div className={tableRow}>
        <div className={rowHeader}>
          Connect custom domains
        </div>
        <div className={tableCell}>{notFeatured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
      </div>
      <div className={tableRow}>
        <div className={rowHeader}>
          Progressive Web Apps (PWA)
        </div>
        <div className={tableCell}>{notFeatured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
      </div>
      <div className={tableRow}>
        <div className={rowHeader}>
          Embeddable WebAR
        </div>
        <div className={tableCell}>{notFeatured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
      </div>

      <div className={tableSubHeader}>Developer Resources &amp; Support</div>
      <div className={tableRow}>
        <div className={rowHeader}>
          Project templates
        </div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
      </div>
      <div className={tableRow}>
        <div className={rowHeader}>
          Modules
        </div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
      </div>
      <div className={tableRow}>
        <div className={rowHeader}>
          Developer Slack community
        </div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
      </div>
      <div className={tableRow}>
        <div className={rowHeader}>
          Tutorials
        </div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
      </div>
      <div className={tableRow}>
        <div className={rowHeader}>
          Email support
        </div>
        <div className={tableCell}>{notFeatured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
      </div>
      <div className={tableRow}>
        <div className={rowHeader}>
          Priority technical support
        </div>
        <div className={tableCell}>{notFeatured}</div>
        <div className={tableCell}>{notFeatured}</div>
        <div className={tableCell}>{notFeatured}</div>
        <div className={tableCell}>{featured}</div>
      </div>
      <div className={tableRow}>
        <div className={rowHeader}>
          Partner Program eligibility
        </div>
        <div className={tableCell}>{notFeatured}</div>
        <div className={tableCell}>{notFeatured}</div>
        <div className={tableCell}>{featured}</div>
        <div className={tableCell}>{featured}</div>
      </div>
    </div>
  )
}

export default PricingFeaturesTable
